import { render, staticRenderFns } from "./ConfContainer.vue?vue&type=template&id=87961dca&scoped=true&lang=pug&"
import script from "./ConfContainer.vue?vue&type=script&lang=js&"
export * from "./ConfContainer.vue?vue&type=script&lang=js&"
import style0 from "./ConfContainer.vue?vue&type=style&index=0&id=87961dca&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87961dca",
  null
  
)

export default component.exports